export const weekDays:weekDayType[] = [
    "domingo",
    "segunda",
    "terca",
    "quarta",
    "quinta",
    "sexta",
    "sabado",
]

export type weekDayType = "domingo"|"segunda"|"terca"|"quarta"|"quinta"|"sexta"|"sabado"

export function getWeekDaysTransformed():string[] {
    return [
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
    ]
}

export function getShortWeekDaysTransformed():string[] {
    return [
        "Dom",
        "Seg",
        "Ter",
        "Qua",
        "Qui",
        "Sex",
        "Sáb",
    ]
}
